import DebugConsole from '@helper/functions/console';

import { invoiceAdminAPI, publicAPI } from './api';
import { handleErrorMessage } from './shared';

export async function getTerminalConfig() {
  try {
    const { data } = await invoiceAdminAPI().get(`/invapi/cashier/terminal/config`, {});
    return data as TerminalProperties[];
  } catch (error) {
    handleErrorMessage(error);
    return undefined;
  }
}

export async function setUserDefaultTerminal({ username, terminalID }) {
  try {
    const res = await invoiceAdminAPI().post(`/invapi/cashier/terminal/cashierterminal`, {
      cashierName: username,
      terminalID,
    });

    DebugConsole.debug(res);

    return true;
  } catch (error) {
    handleErrorMessage(error);
    return undefined;
  }
}

export async function createTerminalConfig(payload) {
  try {
    const { data } = await invoiceAdminAPI().post(`/invapi/admin/terminal/config`, payload);
    return data;
  } catch (error) {
    handleErrorMessage(error);
    return undefined;
  }
}

export async function updateTerminalConfig(payload) {
  try {
    const { data } = await invoiceAdminAPI().put(`/invapi/admin/terminal/config`, payload);
    return data;
  } catch (error) {
    handleErrorMessage(error);
    return undefined;
  }
}
